import Link from '@/lib/link'
import { ContentPage } from '@/components/content-page'

const faqs = [
  {
    q: 'Does NewEmail replace my email provider?',
    a: 'No. NewEmail connects to the provider you already use through IMAP and SMTP. Your address and messages stay with that provider; NewEmail is the app on your devices.',
  },
  {
    q: 'Which providers work?',
    a: 'iCloud, Gmail, Outlook, Yahoo, Fastmail, and most custom domains work when IMAP and SMTP are available. NewEmail can discover common settings automatically and also accepts manual server details.',
  },
  {
    q: 'Where are my passwords stored?',
    a: 'Account passwords are stored in the operating system’s protected credential store, separate from NewEmail’s local mail cache. NewEmail does not put those passwords in its SQLite database.',
  },
  {
    q: 'Does it work offline?',
    a: 'Recently synchronized folders and messages are cached locally. You can browse and search cached mail without a connection; sending and refreshing still require network access.',
  },
  {
    q: 'Why does iCloud ask for an app-specific password?',
    a: 'Apple requires app-specific passwords for third-party mail clients. Create one from your Apple Account security settings and use it instead of your normal Apple ID password.',
  },
  {
    q: 'Which operating systems are available?',
    a: 'NewEmail is designed as the same app on Windows, macOS, Linux, Android, and iOS, with the same accounts, mail, and interface across every screen.',
  },
]

export default function FaqPage() {
  return (
    <ContentPage
      eyebrow="// faq"
      title="Frequently asked questions"
      description="Straight answers about accounts, security, offline mail, and the way NewEmail works."
    >
      <div className="flex flex-col gap-4">
        {faqs.map((faq) => (
          <div key={faq.q} className="rounded-xl border border-border bg-card p-6">
            <h2 className="text-lg font-semibold text-foreground">{faq.q}</h2>
            <p className="mt-2 leading-relaxed text-muted-foreground">{faq.a}</p>
          </div>
        ))}
        <div className="mt-4 rounded-xl border border-primary/30 bg-primary/5 p-6">
          <p className="leading-relaxed text-muted-foreground">
            Still stuck? Visit the{' '}
            <Link href="/support" className="text-primary underline underline-offset-4">
              support page
            </Link>{' '}
            or ask in the{' '}
            <Link href="/forum" className="text-primary underline underline-offset-4">
              community forum
            </Link>
            .
          </p>
        </div>
      </div>
    </ContentPage>
  )
}
